import React, { useState, useMemo, useEffect } from 'react';
import { get, round } from 'lodash';
import Button from '@tds/core-button';
import { Formik, Form, Field } from 'formik';
import { Delete, Edit, IconButton } from '@tds/core-interactive-icon';
import PropTypes from 'prop-types';
import Modal from '../../../design/shared/modal';
import Select from 'react-select';

import {
  customStyles,
  ModalFieldLabel,
  ModalFooter,
  Table,
  Tr,
  Td,
  Th,
  TdImp,
  TdLabel
} from './css';
import { formatCurrency } from '../../../utils/currencyFormatter';
import request from '../../../utils/request';
import { ocdrContractTermFiveYear, ocdrContractTermOneYear, ocdrContractTermThreeYear } from '../../../utils/constant';
import { Error } from '../../../design/elements';

const OcdrAddProduct = ({
  onChange,
  defaultValues,
  orderData,
  productPriceofMC,
  bundleName,
  contractTerm,
  microsoftlicensingSelections,
  setMicrosoftlicensingSelections,
  errorMC
}) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [licensesTerm, setLicensesTerm] = useState([]);
  const [licensesTermData, setLicensesTermData] = useState([]);
  const [optionsOfEditions, setOptionsOfEditions] = useState([]);
  const [disableFieldOneTime, setDisableFieldOneTime] = useState(true);
  const [
    disableFieldMonthlyRecurring,
    setDisableFieldMonthlyRecurring
  ] = useState(true);

  const [errors, setErrors] = useState();

  useEffect(() => {
    if (!microsoftlicensingSelections.length) {
      setMicrosoftlicensingSelections(get(defaultValues, 'selections', []));
    }
  }, [orderData]);

  useEffect(() => {
    const fetchData = async () => {
      let categoriesName = [];
      const dataCategories = await request.get(`/products/categories`);
      dataCategories.data.slice(6, 13).forEach(categoryData => {
        categoriesName.push(categoryData.name);
      });
      setCategories(categoriesName);
    };
    fetchData();
  }, []);

  //  const term = ['OneTime:OnTime','P1M:Monthly','P1Y:Annual','P1Y:Monthly','P1Y:OneTime','P3Y:Annual','P3Y:Monthly','P3Y:Triennial']

  const optionTermToproductTermKey = {
    [ocdrContractTermOneYear]: 'oneYear',
    [ocdrContractTermThreeYear]: 'threeYears',
    [ocdrContractTermFiveYear]: 'fiveYears'
  }
  
  const totals = useMemo(() => {
    let totalmonthlyCharges = 0;
    let totaloneTimeCharge = 0;
    let totalmonthlyChargesDiscount = 0;
    let totaloneTimeChargeDiscount = 0;
    microsoftlicensingSelections.forEach(item => {
      totalmonthlyCharges += round(item.monthlyChargesTotal, 2);
      totaloneTimeCharge += round(item.oneTimeChargeTotal, 2);
      totalmonthlyChargesDiscount += round(item.monthlyDiscountTotal, 2);
      totaloneTimeChargeDiscount += round(item.onetimeDiscountTotal, 2);
    });
    return {
      totalMonthlyPrice: totalmonthlyCharges,
      totalOneTimePrice: totaloneTimeCharge,
      totalMonthlyPriceDiscount: totalmonthlyChargesDiscount,
      totalOneTimePriceDiscount: totaloneTimeChargeDiscount
    };
  }, [microsoftlicensingSelections]);

  const adjustedTotalPrice = useMemo(() => {
    const totalMonthlyPrice = totals.totalMonthlyPrice;
    const totalOneTimePrice = totals.totalOneTimePrice;

    return {
      totalMonthlyPrice,
      totalOneTimePrice
    };
  }, [totals]);

  const adjustedTotalPriceDiscount = useMemo(() => {
    const totalMonthlyPriceDiscount = totals.totalMonthlyPriceDiscount;
    const totalOneTimePriceDiscount = totals.totalOneTimePriceDiscount;

    return {
      totalMonthlyPriceDiscount,
      totalOneTimePriceDiscount
    };
  }, [totals]);

  const showModal = (e) => {
    setModalData(null);
    setDisableFieldOneTime(true);
    setDisableFieldMonthlyRecurring(true);
    setModalVisible(true);
    setOptionsOfEditions([]);
  };

  const onCloseModal = () => {
    setModalVisible(false);
  };

  const addLicencingRow = row => {
    if (row.quantity <= 0) {
      setErrors(prevErrors => ({
        ...prevErrors,
        quantity: 'Quantity of Licenses must be greater than 0'
      }));
      return;
    }
    setMicrosoftlicensingSelections([...microsoftlicensingSelections, row]);
  };

  const editItem = (e, row) => {
    e.preventDefault();
    setModalData(row);
    setModalVisible(true);
  };

  const handleWheel = e => e.target.blur();

  const deleteItem = (e, idx) => {
    e.preventDefault();
    setMicrosoftlicensingSelections([
      ...microsoftlicensingSelections.slice(0, idx),
      ...microsoftlicensingSelections.slice(idx + 1)
    ]);
  };

  useEffect(() => {
    onChange({
      selections: microsoftlicensingSelections,
      adjustedTotalPrice,
      adjustedTotalPriceDiscount
    });
  }, [
    microsoftlicensingSelections,
    adjustedTotalPrice,
    adjustedTotalPriceDiscount
  ]);

  return (
    <div>
      {!!microsoftlicensingSelections.length && (
        <Table>
          <Th>Product</Th>
          <Th>Monthly Charges</Th>
          <Th>Monthly Discount(%)</Th>
          <Th>OneTime Charge</Th>
          <Th>Onetime Discount(%)</Th>
          <Th>Quantity</Th>
          <Th colSpan={2}>Actions</Th>{' '}
          {/* Add this column for edit/delete buttons */}
          {microsoftlicensingSelections.map(
            (
              {
                sku,
                editions,
                quantity,
                monthlyCharges,
                monthlyDiscount,
                oneTimeCharge,
                onetimeDiscount
              },
              idx
            ) => (
              // eslint-disable-next-line react/no-array-index-key
              <Tr key={`${oneTimeCharge}-${monthlyCharges}-${idx}`}>
                <Td>{`${editions},${sku}`}</Td>
                <Td>${monthlyCharges}</Td>
                <Td>{monthlyDiscount}%</Td>
                <Td>${oneTimeCharge}</Td>
                <Td>{onetimeDiscount}%</Td>
                <Td>{quantity}</Td>
                {/* <Td>{formatCurrency(totalCost)}</Td>
                <Td>{formatCurrency(totalPrice)}</Td> */}
                <Td>
                  <IconButton
                    icon={Edit}
                    onClick={e =>
                      editItem(e, microsoftlicensingSelections[idx])
                    }
                  />
                </Td>
                <Td>
                  <IconButton icon={Delete} onClick={e => deleteItem(e, idx)} />
                </Td>
              </Tr>
            )
          )}
          <Tr>
            <TdLabel colSpan={1}>Total</TdLabel>
            <TdImp>{formatCurrency(totals.totalMonthlyPrice)}</TdImp>
            <Td></Td>
            <TdImp>{formatCurrency(totals.totalOneTimePrice)}</TdImp>
          </Tr>
          <Tr>
            <TdLabel colSpan={1}>Total with Discount</TdLabel>
            <TdImp>{formatCurrency(totals.totalMonthlyPriceDiscount)}</TdImp>
            <Td></Td>
            <TdImp>{formatCurrency(totals.totalOneTimePriceDiscount)}</TdImp>
          </Tr>
        </Table>
      )}
      <button
        type="button"
        onClick={showModal}
        className="frg-button color-green"
        disabled={bundleName && contractTerm ? false : true}
        name= "addProductMC"
      >
        Add Product
      </button>
      {errorMC && <Error text={'Field is required'} />}
      <Modal
        open={isModalVisible}
        setOpen={onCloseModal}
        customStyles={customStyles}
        header={modalData ? 'Edit Product' : 'Add Product'}
      >
        <Formik
          initialValues={
            modalData || {
              category: '',
              editions: '',
              sku: '',
              licenseTerm: 0,
              quantity: 0,
              monthlyCharges: 0,
              monthlyDiscount: 0,
              oneTimeCharge: 0,
              onetimeDiscount: 0,
              monthlyChargesTotal: 0,
              monthlyDiscountTotal: 0,
              oneTimeChargeTotal: 0,
              onetimeDiscountTotal: 0,
              currentPriceMonthly: 0,
              currentPriceOneTime: 0,
              bundleName:'',
              contractTerm:''
            }
          }
          onSubmit={values => {
            values['monthlyChargesTotal'] =
              values['currentPriceMonthly'] * values['quantity'];
            values['oneTimeChargeTotal'] =
              values['currentPriceOneTime'] * values['quantity'];
            values['monthlyDiscountTotal'] =
              values['monthlyCharges'] * values['quantity'];
            values['onetimeDiscountTotal'] =
              values['oneTimeCharge'] * values['quantity'];
            if (modalData) {
              // Update existing row
              const updatedSelections = [...microsoftlicensingSelections];
              updatedSelections[
                microsoftlicensingSelections.indexOf(modalData)
              ] = values;
              setMicrosoftlicensingSelections(updatedSelections);
            } else {
              // Add new row
              addLicencingRow(values);
            }
            if (values.quantity !== 0 && (!errors || !errors.quantity)) {
              onCloseModal();
            }
          }}
        >
          {({ values, setFieldValue, resetForm }) => (
            <Form>
              <div>
                <ModalFieldLabel>Category:</ModalFieldLabel>
                <Field
                  as="select"
                  id="category"
                  name="category"
                  className="frg-input-field color-light"
                  onChange={e => {
                    resetForm();
                    const selectedCategory = e.target.value;
                    setFieldValue('category', selectedCategory);
                    setFieldValue('bundleName',bundleName);
                    if (productPriceofMC[selectedCategory]) {
                      const optionData = [];
                      productPriceofMC[selectedCategory].forEach(data => {
                        optionData.push({
                          value: data.name,
                          label: data.name
                        });
                      });
                      setOptionsOfEditions(optionData);
                    }
                  }}
                  required
                >
                  <option value="">Select Category</option>
                  {categories.map(category => (
                    <option key={category} value={category}>
                      {category}
                    </option>
                  ))}
                </Field>
              </div>
              <div>
                <ModalFieldLabel htmlFor="Editions">Editions:</ModalFieldLabel>
                <Select
                  value={
                    optionsOfEditions.find(
                      option => option.value === values.editions
                    ) || null
                  }
                  onChange={option => {
                    const selectedCategory = option.value;
                    let addLicensesTermData = [];
                    setFieldValue('editions', selectedCategory);

                    const pricesData = productPriceofMC[values.category]
                      .filter(
                        skuProduct => skuProduct.name === selectedCategory
                      )
                      .map(skuProduct => skuProduct.prices);

                    const skuName = productPriceofMC[values.category]
                      .filter(
                        skuProduct => skuProduct.name === selectedCategory
                      )
                      .map(skuProduct => skuProduct.sku);
                    setFieldValue('sku', skuName[0]);
                    Object.entries(pricesData[0]).map(key => {
                      if (key[0] === 'OneTime:OneTime') {
                        addLicensesTermData.push({
                          value: `OneTime (${key[1]})`,
                          prices: key[1],
                          payment: 'oneTime'
                        });
                      } else if (key[0] === 'P1M:Monthly') {
                        addLicensesTermData.push({
                          value: `1 Month (${key[1]})`,
                          prices: key[1],
                          payment: 'monthly'
                        });
                      } else if (key[0] === 'P1Y:Annual') {
                        addLicensesTermData.push({
                          value: `Upfront OneTime (${key[1]})`,
                          prices: key[1],
                          payment: 'oneTime'
                        });
                      } else if (key[0] === 'P1Y:Monthly') {
                        addLicensesTermData.push({
                          value: `12 Months (${key[1]})`,
                          prices: key[1],
                          payment: 'monthly'
                        });
                      } else if (key[0] === 'P1Y:OneTime') {
                        addLicensesTermData.push({
                          value: `OneTime (${key[1]})`,
                          prices: key[1],
                          payment: 'oneTime'
                        });
                      } else if (key[0] === 'P3Y:Annual') {
                        addLicensesTermData.push({
                          value: `Upfront OneTime (${key[1]})`,
                          prices: key[1],
                          payment: 'oneTime'
                        });
                      } else if (key[0] === 'P3Y:Monthly') {
                        addLicensesTermData.push({
                          value: `36 Months (${key[1]})`,
                          prices: key[1],
                          payment: 'monthly'
                        });
                      } else if (key[0] === 'P3Y:Triennial') {
                        addLicensesTermData.push({
                          value: `Triennial (${key[1]})`,
                          prices: key[1],
                          payment: 'monthly'
                        });
                      }
                    });
                    setLicensesTerm(
                      addLicensesTermData.map(data => data.value)
                    );
                    setLicensesTermData(addLicensesTermData);
                  }}
                  options={optionsOfEditions}
                  isSearchable={true}
                  required
                />
              </div>
              <div>
                <ModalFieldLabel>Term & Payment:</ModalFieldLabel>
                <Field
                  as="select"
                  id="licenseTerm"
                  name="licenseTerm"
                  className="frg-input-field color-light"
                  value={values.licenseTerm}
                  onChange={e => {
                    const selectedTerm = e.target.value;
                    setFieldValue('licenseTerm', selectedTerm); // Reset Subscription Line Option
                    setFieldValue('monthlyCharges', 0);
                    setFieldValue('monthlyDiscount', 0);
                    setFieldValue('currentPriceMonthly', 0);
                    setFieldValue('oneTimeCharge', 0);
                    setFieldValue('onetimeDiscount', 0);
                    setFieldValue('currentPriceOneTime', 0);

                    const bundleData = productPriceofMC[values.category]
                      .filter(skuProduct => skuProduct.name === values.editions)
                      .map(skuProduct => skuProduct.productBundles);

                    licensesTermData.forEach(termData => {
                      if (termData.value === selectedTerm) {
                        if (termData.payment === 'oneTime') {
                          setFieldValue('oneTimeCharge', termData.prices);
                          setFieldValue('currentPriceOneTime', termData.prices);
                          setDisableFieldOneTime(false);

                          if (bundleData[0].length > 0) {
                            bundleData[0].forEach(data => {
                              if(data.productBundle.name === bundleName){
                                if(contractTerm === '1 year'){
                                  setFieldValue('onetimeDiscount',data.oneYear);
                                  setFieldValue('contractTerm','oneYear');
                                }else if(contractTerm === '3 year'){
                                  setFieldValue('onetimeDiscount',data.threeYears);
                                  setFieldValue('contractTerm','threeYears');
                                }else if(contractTerm === '5 year'){
                                  setFieldValue('onetimeDiscount',data.fiveYears);
                                  setFieldValue('contractTerm','fiveYears');
                                }else {
                                  setFieldValue('contractTerm','');
                                }
                              
                              if(data[optionTermToproductTermKey[contractTerm]]){
                                  setFieldValue('oneTimeCharge',
                                  ( termData.prices -
                                    termData.prices * (data[optionTermToproductTermKey[contractTerm]] / 100)
                                  ).toFixed(2));
                              }
                              }
                            });
                          }
                        } else {
                          setDisableFieldOneTime(true);
                        }

                        if (termData.payment === 'monthly') {
                          setFieldValue('monthlyCharges', termData.prices);
                          setFieldValue('currentPriceMonthly', termData.prices);
                          setDisableFieldMonthlyRecurring(false);

                          if (bundleData[0].length > 0) {
                            bundleData[0].forEach(data => {
                              if(data.productBundle.name === bundleName){
                                if(contractTerm === '1 year'){
                                  setFieldValue('monthlyDiscount',data.oneYear);
                                  setFieldValue('contractTerm','oneYear');
                                }else if(contractTerm === '3 year'){
                                  setFieldValue('monthlyDiscount',data.threeYears);
                                  setFieldValue('contractTerm','threeYears');
                                }else if(contractTerm === '5 year'){
                                  setFieldValue('monthlyDiscount',data.fiveYears);
                                  setFieldValue('contractTerm','fiveYears');
                                }else {
                                  setFieldValue('contractTerm','');
                                }

                          if(data[optionTermToproductTermKey[contractTerm]]){
                                setFieldValue('monthlyCharges',
                                ( termData.prices -
                                  termData.prices * (data[optionTermToproductTermKey[contractTerm]] / 100)
                                ).toFixed(2));
                            }
                              }
                            });
                          }
                        } else {
                          setDisableFieldMonthlyRecurring(true);
                        }
                      }
                    });
                  }}
                  required
                >
                  <option value="">Select License Term</option>
                  {licensesTerm.map(license => (
                    <option key={license} value={license}>
                      {license}
                    </option>
                  ))}
                </Field>
              </div>
              <div>
                <ModalFieldLabel htmlFor="cost">Quantity:</ModalFieldLabel>
                <Field
                  type="number"
                  id="quantity"
                  name="quantity"
                  className="frg-input-field color-light"
                  value={values.quantity}
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  onChange={e => {
                    const { value } = e.target;
                    setFieldValue('quantity', value);
                    setErrors(prevErrors => ({
                      ...prevErrors,
                      quantity:
                        value > 0
                          ? ''
                          : 'Quantity of Licenses must be greater than 0'
                    }));
                  }}
                  required
                />
                {errors && errors.quantity && (
                  <div style={{ color: 'red' }}>{errors.quantity}</div>
                )}
              </div>
              <div>
                <ModalFieldLabel htmlFor="cost">
                  Recurring Charge:
                </ModalFieldLabel>
                <Field
                  type="number"
                  id="monthlyCharges"
                  name="monthlyCharges"
                  className="frg-input-field color-light"
                  value={values.monthlyCharges}
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  disabled
                />
              </div>
              <div>
                <ModalFieldLabel htmlFor="cost">
                  Recurring Discount (%):
                </ModalFieldLabel>
                <Field
                  disabled={disableFieldMonthlyRecurring}
                  type="number"
                  id="monthlyDiscount"
                  name="monthlyDiscount"
                  className="frg-input-field color-light"
                  value={values.monthlyDiscount}
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  onChange={e => {
                    const selectedTerm = e.target.value;
                    setFieldValue('monthlyDiscount', selectedTerm);
                    licensesTermData.forEach(data => {
                      if (data.value === values.licenseTerm) {
                        setFieldValue(
                          'monthlyCharges',
                          (
                            data.prices -
                            data.prices * (selectedTerm / 100)
                          ).toFixed(2)
                        );
                      }
                    });
                  }}
                />
              </div>
              <div>
                <ModalFieldLabel htmlFor="cost">
                  One Time Charge:
                </ModalFieldLabel>
                <Field
                  type="number"
                  id="oneTimeCharge"
                  name="oneTimeCharge"
                  className="frg-input-field color-light"
                  value={values.oneTimeCharge}
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  disabled
                />
              </div>
              <div>
                <ModalFieldLabel htmlFor="cost">
                  One time Discount (%):
                </ModalFieldLabel>
                <Field
                  disabled={disableFieldOneTime}
                  type="number"
                  id="onetimeDiscount"
                  name="onetimeDiscount"
                  className="frg-input-field color-light"
                  value={values.onetimeDiscount}
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  onChange={e => {
                    const selectedOneTime = e.target.value;
                    setFieldValue('onetimeDiscount', selectedOneTime);
                    licensesTermData.forEach(data => {
                      if (data.value === values.licenseTerm) {
                        setFieldValue(
                          'oneTimeCharge',
                          (
                            data.prices -
                            data.prices * (selectedOneTime / 100)
                          ).toFixed(2)
                        );
                      }
                    });
                  }}
                />
              </div>
              <ModalFooter>
                <Button type="submit">Add</Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

OcdrAddProduct.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultValues: PropTypes.shape({}).isRequired,
  orderData: PropTypes.shape({}).isRequired
};

export default OcdrAddProduct;
